<div class="container-fluid">
    <div class="row mt-1">
      <app-breadcrumb [breadcrumbitems]="breadcrumbItems"></app-breadcrumb>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="accordion-wrapper mb-5">
                <div class="accordion mb-3" id="homeAccordianOne">
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex flex-row justify-content-between">
                            <span class="commonFont pt-2">Safety Risk Ranking - {{supplierCode}}</span>
                            <button class="btn headButton" type="button" data-bs-toggle="collapse" id="accordion3Btn"
                            accordianActive="true" data-bs-target="#collapsesearchfilter1" aria-expanded="true"
                            aria-controls="collapsesearchfilter1" (click)="isOpen2=!isOpen2">
            
                            <img class="clpseBtn collapsesearchfilterBtn" [ngClass]="{'active':isOpen2}" alt="img">
                            </button>
                      </div>
                    </div>
                    </div>
                </div>
                <div id="collapsesearchfilter1" class="collapse show" aria-labelledby="headingOne"
                  data-bs-parent="#proposalHist">
                    <div class="cardBody">
                        <div class="accordion-main p-2">
                            <form [formGroup]="safetyForm">
                                <div class="d-flex mt-3 mb-3">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-6 col-md-4">
                                                <div class="d-flex flex-column">
                                                    <span class="label-tmna">Target</span>
                                                    <input class="input-tmna input-tmna-disabled" formControlName="target" type="text" placeholder="Enter Target" style="width: 100%;" readonly>
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-4">
                                                <div class="d-flex flex-column">
                                                    <span class="label-tmna">Risk Rating</span>
                                                    <input class="input-tmna" formControlName="riskRating" type="text" placeholder="Enter Risk Rating" style="width: 100%;">
                                                </div>
                                            </div>
                                            <div class="col-6 col-md-4">
                                                <div class="d-flex flex-column">
                                                    <span class="label-tmna">Comment</span>
                                                    <input class="input-tmna" formControlName="comment" type="text" placeholder="Enter Comment" style="width: 100%;" maxlength="100">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  
<nav class="navbar navbar-expand-lg justify-content-end footer-tab mt-2">
    <div class="saveFooter mb-3 ">
        <button class="addButton ms-3 me-2" [disabled]="role == 'PurappsBuyer' || role == 'PurappsManager'" [ngClass]="{ disableSaveBtn: role == 'PurappsBuyer' || role == 'PurappsManager' }" (click)="saveSafetyRanking()">SAVE</button>
        <button class="closeButton ms-3" (click)="cancelCommodity()">CANCEL</button>
    </div>
</nav>